<template>
  <div class="flex items-center justify-between p-4 bg-yellow-300 rounded w-full">
    <div class="flex items-center">
      <div class="flex-shrink-0 mr-2 w-4 h-4 fill-gray-800">
        <i class="far fa-copy" />
      </div>
      <div class="text-gray-800 text-sm font-medium">
        Warning: Duplicate Lead.
      </div>
    </div>
    <Link :href="`/leads/${id}/edit`">
      <button class="text-gray-800  hover:underline text-sm" tabindex="-1" type="button">View Duplicate</button>
    </Link>
  </div>
</template>

<script>
import { Link } from '@inertiajs/vue3'

export default {
  components: {
    Link,
  },
  props: {
    id: Array,
  },
}
</script>
